<template>
  <div class="flex flex-col gap-4 mb-4">
    <ul class="list-disc pl-6 space-y-4">
      <li>
        Dans le profil, s'assurer que la griffe par défaut, marquée par
        <PButton size="icon" mode="tertiary-borderless" class="inline-flex">
          <OhVueIcon :name="starIconFill" :scale="1" />
        </PButton>
        , est bien celle à utiliser. Sinon, en sélectionner une autre en cliquant sur son
        <PButton size="icon" mode="tertiary-borderless" class="inline-flex">
          <OhVueIcon :name="starIconLine" :scale="1" />
        </PButton>
      </li>
      <li>
        Dans le parapheur à signer, s'assurer que tous les documents à signer ont fait l'objet d'un prépositionnement de
        signature : présence de
        <span class="rounded-full bg-green-tilleul-verveine-925 p-1 mr-1 inline-flex">
          <span class="text-sm">1</span>
          <OhVueIcon scale="1" :name="postItIcon" class="mt-1v" />
        </span>
        à gauche du nom du document
      </li>
      <li>
        Dans la zone "Documents" du parapheur, je lance la signature via
        <PButton size="icon" mode="tertiary-borderless" class="inline-flex">
          <OhVueIcon :name="menuIcon" :scale="1" />
        </PButton>
        puis
        <span class="font-bold">Signer le parapheur</span>
      </li>

      <li v-if="padesEnabled" class="leading-10">
        Un écran qui résume tous les parapheurs et les documents à signer s'affiche : Cliquer sur
        <PButton mode="primary" size="sm" class="inline-flex"> Signer</PButton>
        pour signer avec une griffe et un certificat numérique du ministère, sur
        <PButton mode="primary" size="sm" class="inline-flex">Signer + identité renforcée</PButton>
        (*) pour signer avec une griffe et un certificat électronique nominatif présent sur support physique (ma carte
        agent ou ma clé Certigna) ou directement chargé sur mon poste ou sur
        <PButton mode="secondary" size="sm" class="inline-flex"> Annuler</PButton>
        pour annuler. (*) La signature avec un certificat nominatif requiert l'installation sur le poste d'un logiciel
        spécifique (Smart Card Middleware Desktop Version 6.23.50.5 ou ultérieure).
      </li>
      <li v-else>
        Un écran qui résume tous les parapheurs et les documents à signer s'affiche : Cliquer sur
        <PButton mode="primary" size="sm" class="inline-flex"> Signer</PButton>
        pour confirmer ou sur
        <PButton mode="secondary" size="sm" class="inline-flex"> Annuler</PButton>
        pour annuler
      </li>
      <li>
        A la fin de l'opération, vous pouvez passer le parapheur à l'étape suivante, ou bien le garder dans votre
        bannette "En cours à mon niveau"
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
import { PButton, useIcons } from "@pasta/box-v2";
import { OhVueIcon } from "oh-vue-icons";
import { RiMore2Fill, RiStarFill, RiStarLine, RiStickyNoteLine } from "oh-vue-icons/icons";
import { computed } from "vue";
import { useSimpleFeatureStore } from "../../stores/simple-features.store.ts";

const [menuIcon, starIconLine, starIconFill, postItIcon] = useIcons(
  RiMore2Fill,
  RiStarLine,
  RiStarFill,
  RiStickyNoteLine
);

const padesEnabled = computed(() => useSimpleFeatureStore().pades.enabled);
</script>
